<style src="./ContextListFilter.scss" lang="scss"></style>
<template>
  <section
    class="list-filter">
    <span class="filtertitle">{{ title }}</span>
    <input
      type="text"
      class="cp1-small-textbox searchbox"
      v-model="searchText"
      @debounced="searchByText">

    <ul class="list">
      <li
        v-for="(lab, labIdx) in filterList"
        :key="labIdx"
        class="item">
        <label class="item">
          <input
            type="checkbox"
            class="checklab"
            :value="lab.id"
            v-model="filters.filterValue"
            @change="sendFilter">
          <span class="label">{{ lab.id }}</span>
        </label>
      </li>
    </ul>
  </section>
</template>

<script>
import { DebounceDirective } from '@/components/primitives/helpers/debounce/Debounce'

export default {
  name: 'ListContextFilter',
  directives: { debounceDirective: DebounceDirective },
  props: {
    title: {
      default: 'Filtro'
    },
    columnId: {
      default: null
    },
    activeOptions: {
      default: () => ([])
    }
  },
  data: () => ({
    searchText: '',
    filters: {
      filterType: 'LIST',
      filterValue: []
    }
  }),
  computed: {
    filterList () {
      const regSearch = new RegExp(this.searchText.trim(), 'gi')
      const groupedFilter = this.$store.getters['ItemPricing/GROUPED_FILTER_BY_FIELD'](this.columnId)
      const filteredList = Object.keys(groupedFilter).filter(a => regSearch.test(a))
      const sortedList = filteredList
        .map(a => ({
          checked: a.checked,
          id: a
        }))
        .sort((a, b) => {
          return this.filters.filterValue.includes(a.id) ? -1 : 1
        })
      return sortedList
    }
  },
  mounted () {
    this.filters.filterValue = this.activeOptions
  },
  methods: {
    sendFilter () {
      const filter = {
        columnId: this.columnId,
        filterType: this.filters.filterType,
        filterValue: this.filters.filterValue
      }
      this.$emit('filter-value', filter)
    },
    searchByText () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-list-filter/ContextListFilter.vue